import { Configurable, forLocale } from '@crystal/config'

export const config = Configurable.props({
  callCenterNumber: forLocale({
    KR: '1588-8241',
  }),
})
